export const PIGGY_BANK_CHEST = {
  GET_PIGGY_BANK_CHEST_CONFIG: 'GET_PIGGY_BANK_CHEST_CONFIG',
}
